<template>
    <div class="container">
        <div class="breadcrumbs col-12 d-flex align-items-center py-3 mt-2 gap-2">
            <div v-for="breadcrumb, key in breadcrumbs">
                <div class="d-inline" v-if="key === breadcrumbs.length - 1">
                    <span class="current fw-bold">{{ breadcrumb.name }}</span>
                </div>
                <div class="d-inline" v-else>
                    <div class="d-inline" v-if="breadcrumb.link">
                        <a class="d-inline-block text-black" :href="breadcrumb.link">{{ breadcrumb.name }}</a> <i class="fa-light fa-arrow-right"></i>
                    </div>
                    <div class="d-inline" v-else>
                        <span>{{ breadcrumb.name }} <i class="fa-solid fa-arrow-right"></i> </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h1 class="mb-3">{{ model.h1 }}</h1>
                <div v-html="model.range_description" class="fw-light"></div>
            </div>
        </div>
    </div>
    <div class="container">
        <br>
        <slimline-reg-size-form :postcode="postcode" :options="sizeOptions" :image-base-path="tyreImagePath"></slimline-reg-size-form>
        <div v-if="popularTyreRanges.length > 0">
            <div class="row">
                <div class="col-12">
                    <h2 class="h3 mt-4 mb-2">Most popular {{ model.name }} Tyres</h2>
                    <hr class="hr-navy">
                </div>
                <div class="col-12 col-md-6 col-lg-3 mb-3" v-for="tyre, key in popularTyreRanges" :key="key">
                    <model-tyre
                        :tyre="tyre"
                        :tyre-image-path="tyreImagePath"
                        :brand-image-path="brandImagePath"
                    ></model-tyre>
                </div>
            </div>
        </div>
    </div>
    <br/>
    <br/>
    <teleport to="body">
        <info-modal></info-modal>
    </teleport>
</template>

<script>
    export default {
        props: ['manufacturer', 'model', 'tyreImagePath', 'brandImagePath', 'popularTyreRanges', 'sizeOptions', 'postcode', 'breadcrumbs'],
        mounted() {
			//removes loading placeholder - fixes CLS issues
            if (document.contains(document.querySelector('#loadingPlaceholder'))) {
			    document.querySelector('#loadingPlaceholder').style.display = 'none';
            }
        },
        computed: {
            manufacturerBackgroundImage() {
                let manufacturer_image = ('Backgrounds/Asda%20Tyres/Manufacturers/' + (this.manufacturer.slug) + '.jpg');
                return 'background: url(' + (this.tyreImagePath + manufacturer_image) + ') no-repeat; background-size: cover; height: 427px;';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .manufacturer-hero {
        background: #e9ecef !important;
        span {
            background-color: inherit !important;
        }
        .hero-img {
            max-width: 75%;
        }
    }
    .title-text {
        @media screen and (min-width: 1200px) {
            max-width: 450px;
        }
    }
    .manufacturer-logo {
        @media screen and (min-width: 576px) {
            max-width: 150px;
            position: absolute;
            left: -85px;
            top: 80px;
        }
    }
    .brand-image {
        max-width: 170px;
    }
    .main-content {
        .slimline {
            @media screen and (min-width: 992px) {
                margin-top: -35px !important;
            }
        }
    }
</style>